export const Pages = {
  LOGIN: '/',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_WITH_TOKEN: (token: string) =>
    `/reset-password?confirmationToken=${token}`,
  CONFIRM_ACCOUNT: '/confirm-account',
  DASHBOARD: '/dashboard',
  DASHBOARD_FINALIZERS: '/dashboard-finalizers',
  PROCESSING: '/processing',
  REPORTS: '/reports',
  BLOCK_ORDER: '/block-order',
  SHIPMENTS: '/shipments',
  RETURNS: '/returns',
  NOTIFICATIONS: '/notifications',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SETTINGS_USERS_INTERNAL: '/settings/users/internal',
  SETTINGS_USERS_EXTERNAL: '/settings/users/external',
  SETTINGS_USERS_PERMISSIONS: '/settings/users/permissions',
  SETTINGS_FULFILLMENT: '/settings/fulfillment',
  SETTINGS_FULFILLMENT_MASTER_BOXES: '/settings/fulfillment/master-boxes',
  NO_ACCESS: '/no-access',
} as const
